export default function RightArrowIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66108 6.29772L13.7898 10.7255L13.7898 9.64344L9.66108 14L11.6116 14L15 10.5404L15 9.82852L11.6116 6.29772L9.66108 6.29772ZM6.11604 9.42988L6.11604 10.8821L13.6759 10.8821L13.6759 9.42988L6.11604 9.42988Z"
        fill="white"
      />
    </svg>
  );
}
